import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
export const pageUrl = '/[locale]/streambot/fundraising-events/[slug]/[widget]?token'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type StreambotPageProps = PageProps<typeof pageUrl, { token?: string; preview?: 'true' | '' }>
